import UserShuftiProDocuments from './UserShuftiProDocuments';

export default UserShuftiProDocuments;
